import styled from "styled-components";

export const Styles = styled.div`
    .tabs {
        display: flex;
        padding-bottom: 25px;
        @media screen and (max-width: 600px) {
            overflow-x: scroll;
            overflow-y: hidden;
        }

        .tab {
            font-family: IRANSans;
            font-style: normal;
            font-weight: normal;
            font-size: 20px;
            line-height: 26px;
            letter-spacing: -0.025em;
            font-feature-settings: "pnum" on, "onum" on;
            color: #5b616e;
            margin-right: 40px;
            white-space: nowrap;
            cursor: pointer;
        }

        .live-badge {
            display: inline-flex;
            align-items: center;
            align-self: center;
            gap: 5px;
            margin-right: 28px;
            padding: 3px 8px;
            color: #1b7f3a;
            background: #e8f7ed;
            border: 1px solid #bce7c9;
            border-radius: 20px;
            font-family: IRANSans;
            font-size: 11px;
            font-weight: 600;
            line-height: 16px;
            white-space: nowrap;
        }

        .live-dot {
            width: 7px;
            height: 7px;
            background: #25a244;
            border-radius: 50%;
            box-shadow: 0 0 0 0 rgba(37, 162, 68, 0.45);
            animation: live-pulse 1.8s infinite;
        }

        .active {
            color: #1a1a1c;
            border-bottom: solid 2px #1a1a1c;
            font-weight: 600;
        }
    }

    @keyframes live-pulse {
        0% {
            box-shadow: 0 0 0 0 rgba(37, 162, 68, 0.45);
        }
        70% {
            box-shadow: 0 0 0 6px rgba(37, 162, 68, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(37, 162, 68, 0);
        }
    }
`;
